import { c as _c } from "react/compiler-runtime";
import React, { ReactNode } from "react";
import elements from "./PageContent.module.scss";
export const PageContent: React.FC<{
  children: ReactNode[] | ReactNode;
}> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <section className={elements.pageContent}>{children}</section>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};